import plugin_vue3_A0OWXRrUgq from "D:/App/Qrgateway.com/homepage_n3.2/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "D:/App/Qrgateway.com/homepage_n3.2/.nuxt/components.plugin.mjs";
import vueuse_head_plugin_D7WGfuP1A0 from "D:/App/Qrgateway.com/homepage_n3.2/node_modules/nuxt/dist/head/runtime/lib/vueuse-head.plugin.mjs";
import router_Pg0DINazwm from "D:/App/Qrgateway.com/homepage_n3.2/node_modules/nuxt/dist/pages/runtime/plugins/router.mjs";
import prefetch_client_3cwHvxIDEX from "D:/App/Qrgateway.com/homepage_n3.2/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.mjs";
import mount_plugin_client_GyWXdaUM8H from "D:/App/Qrgateway.com/homepage_n3.2/node_modules/nuxt-delay-hydration/dist/runtime/mount-plugin.client.mjs";
import templates_pwa_client_20eddd30_m8YVL3XkCF from "D:/App/Qrgateway.com/homepage_n3.2/.nuxt/templates.pwa.client.20eddd30.ts";
import plugin_t2GMTTFnMT from "D:/App/Qrgateway.com/homepage_n3.2/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import composition_sLxaNGmlSL from "D:/App/Qrgateway.com/homepage_n3.2/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "D:/App/Qrgateway.com/homepage_n3.2/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_OrkQhMqHci from "D:/App/Qrgateway.com/homepage_n3.2/node_modules/@nuxt/image-edge/dist/runtime/plugin.mjs";
import colorpicker_client_w2ImNmM5pJ from "D:/App/Qrgateway.com/homepage_n3.2/plugins/colorpicker.client.ts";
import notification_client_B9MZmzG6b3 from "D:/App/Qrgateway.com/homepage_n3.2/plugins/notification.client.ts";
export default [
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  vueuse_head_plugin_D7WGfuP1A0,
  router_Pg0DINazwm,
  prefetch_client_3cwHvxIDEX,
  mount_plugin_client_GyWXdaUM8H,
  templates_pwa_client_20eddd30_m8YVL3XkCF,
  plugin_t2GMTTFnMT,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  plugin_OrkQhMqHci,
  colorpicker_client_w2ImNmM5pJ,
  notification_client_B9MZmzG6b3
]